import axios from '@/plugins/axios'
import format from 'date-fns/format'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'

export default {
  namespaced: true,

  state: {
    loading: false,
    dialogVisibleVideoCharts: false,
    myvideos: [],
    tracks: [],
    page: 1,
    page_size: 10,
    order_column: 'title',
    order_type: 'asc',
    video_chart: [],
    date_range: [
      format(subDays(new Date(), 7), 'yyyy-MM-dd'),
      format(addDays(new Date(), 1), 'yyyy-MM-dd')
    ],
    csv: 0,
    LineChartSett: {
      width: 'auto',
      height: 500,
      is3D: true,
      colors: ['#085178', '#e80021', '#1b9e77', '#2c67a5'],
      curveType: 'none',
      isStacked: 'relative',
      vAxis: {
        maxAlternation: 4,
        minorGridlines: {
          count: 15
        },
        minValue: 0,
        slantedText: true,
        slantedTextAngle: 70,
        gridlines: {
          count: 15
        },
        textStyle: {
          fontSize: 12
        },
        format: 'short',
        viewWindowMode: 'pretty'
      },
      hAxis: {
        format: 'short',
        viewWindowMode: 'pretty',
        textStyle: {
          fontSize: 13
        },
        color: '#FF0000'
      },
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 16,
          isHtml: true
        },
        showColorCode: true
      },
      lineWidth: 2.3,
      legend: {
        position: 'bottom',
        textStyle: {
          color: '#303133',
          fontSize: 14,
          bold: true
        }
      },
      chartArea: {
        left: '15%',
        top: '5%',
        width: '100%',
        height: '70%'
      }
    }
  },

  mutations: {
    setLoading(state, payload) {
      state.loading = payload
    },
    setChartDialog(state, payload) {
      state.dialogVisibleVideoCharts = payload
    },
    setMyVideos(state, payload) {
      state.myvideos = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setVideoChart(state, payload) {
      state.video_chart = payload
    },
    setDateRange(state, payload) {
      state.date_range = [payload[0], payload[1]]
    },
    setVideoTracks(state, payload) {
      state.tracks = payload
    },
    setCsv(state, payload) {
      state.csv = payload
    },
  },

  actions: {
    readMyVideos({ commit, state }, filters = null) {
      commit('setLoading', true)

      let ls = localStorage.getItem('video_report_filter')
      filters = JSON.parse(ls)

      axios.artist
        .get('myvideos', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            csv: state.csv,
            artist:
              this.state.artistDashboard.artist_label !== null
                ? this.state.artistDashboard.artist_label.id
                : null,
            track:
              this.state.artistDashboard.artist_track !== null
                ? this.state.artistDashboard.artist_track.id
                : null,
            ...filters
          }
        })
        .then(r => {
          if(state.csv == 1){
            state.csv = 0
            const url = window.URL.createObjectURL(new Blob([r.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'report_my_videos.csv')
            document.body.appendChild(link)
            link.click()
          }
          else{
            commit('setMyVideos', r.data.data)
          }
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    readVideoChart({ commit }, data) {
      axios.artist
        .get(`myvideos/${data.id}`, {
          params: {
            start: data.start,
            end: data.end,
            artist:
              this.state.artistDashboard.artist_label !== null
                ? this.state.artistDashboard.artist_label.id
                : null
          }
        })
        .then(r => {
          commit('setVideoChart', r.data.data)
          // commit('setLoading', false)
        })
        .catch(() => {
          commit('setVideoChart', [])
          // commit('setLoading', false)
        })
    },
    readVideoTracks({ commit }, data) {
      axios.artist
        .get(`myvideos/${data.id}`, {
          params: {
            tracks: data.tracks,
            artist:
              this.state.artistDashboard.artist_label !== null
                ? this.state.artistDashboard.artist_label.id
                : null
          }
        })
        .then(r => {
          commit('setVideoTracks', r.data.data)
          // commit('setLoading', false)
        })
        .catch(() => {
          commit('setVideoTracks', [])
          // commit('setLoading', false)
        })
    }
  },
  getters: {
    video_chart_views: state => {
      let result = [['Date', 'Views']]
      state.video_chart.map(s => {
        const date = new Date(s.date)
        result.push([date.toDateString().slice(3, 15), s.views])
      })
      return result
    },
    video_chart_views_daily: state => {
      let result = [['Date', 'Daily']]
      state.video_chart.map(s => {
        const date = new Date(s.date)
        result.push([date.toDateString().slice(3, 15), s.daily])
      })
      return result
    },
    video_chart_subscribers: state => {
      let result = [['Date', 'Subscribers']]
      state.video_chart.map(s => {
        const date = new Date(s.date)
        result.push([date.toDateString().slice(3, 15), s.subscribers])
      })
      return result
    },
    video_chart_subscribers_daily: state => {
      let result = [['Date', 'Daily']]
      state.video_chart.map(s => {
        const date = new Date(s.date)
        result.push([date.toDateString().slice(3, 15), s.daily_subscribers])
      })
      return result
    }
  }
}
